// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconPhoneRinging = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M12 3a9 9 0 019 9h2c0-6.075-4.925-11-11-11z" />,
    <path
      fillRule="evenodd"
      d="M1 5h5.986l3.042 3.042-1.857 4.715 3.073 3.072 4.714-1.857L19 17.014V23h-1c-5.102 0-9.368-1.806-12.359-4.873C2.654 15.063 1 10.804 1 6zm2.027 2c.21 3.914 1.662 7.286 4.046 9.73 2.392 2.453 5.773 4.027 9.927 4.244v-3.131l-1.53-1.53-4.713 1.858-4.928-4.927 1.857-4.715L6.157 7z"
    />,
    <path d="M17 12a5 5 0 00-5-5V5a7 7 0 017 7z" />
  );
export default SvgIconPhoneRinging;
